module.exports = __webpack_public_path__ + "static/img/wechat_img.dd043954.png";